// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"68f97d63","455":"b6f209c3"}[chunkId] + ".chunk.js";
};